import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { Helmet } from 'react-helmet-async';
import SunSvg from './images/sun.inline.svg';

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  min-height: 100vh;
  background: var(--earth-fm--color--yellow);
  text-align: center;

  svg {
    width: 100%;
    max-width: 150px;
    height: auto;
  }

  @media (prefers-reduced-motion: no-preference) {
    svg {
      path:first-of-type {
        animation: ${spin} 10s linear infinite;
        transform-origin: center;
      }
    }
  }

  @media (min-width: 992px) {
    svg {
      max-width: 226px;
    }
  }
`;

const Message = styled.p`
  margin: 20px 0 0;
  font: inherit;
`;

interface Props {
  message?: React.ReactNode;
}

export default function LoadingScreen({ message = 'Just a moment... the sun is rising!' }: Props) {
  return (
    <Wrapper>
      {/* Set theme-color to match loading screen background for iOS status bar */}
      <Helmet>
        <meta name="theme-color" content="#f6e53b" />
      </Helmet>
      <div className="container">
        <SunSvg />
        <Message>{message}</Message>
      </div>
    </Wrapper>
  );
}
